import { StoreApi, UseBoundStore } from 'zustand'

type State = object

type WithSelectors<S> = S extends { getState: () => infer T }
  ? S & { use: { [K in keyof T]: () => T[K] } }
  : never

const createSelectors = <S extends UseBoundStore<StoreApi<State>>>(_store: S) => {
  const store = _store as WithSelectors<typeof _store>
  store.use = {}
  const stateKeys = Object.keys(store.getState()) as Array<keyof State>
  for (const k of stateKeys) {
    ;(store.use as any)[k] = () => store(s => s[k])
  }

  return store
}

export default createSelectors
